// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KgjXQwtckVwJL7rr:hover{background-color:var(--py-neutral-2) !important}.KgjXQwtckVwJL7rr:active{color:var(--py-neutral-0) !important;background-color:var(--py-neutral-7) !important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"closeButton": `KgjXQwtckVwJL7rr`
};
export default ___CSS_LOADER_EXPORT___;
